export default {
	"components.Revise": "修改"
}